const d = 'https://mazey.cn/feperf';

export const monitotAPI = {
  perfDay: `${d}/monitor/perf/day`,
  topics: `${d}/monitor/get/topic`,
  addTopic: `${d}/monitor/add/topic`,
};
